import styled from 'styled-components';
import { CheckoutAssistedFinanceStyled } from '../../CheckoutAssistedFinanceStyled';

export const CheckoutAssistedFinanceStyledGBOV = styled(CheckoutAssistedFinanceStyled)`
    
`;
